{
  "removeButtonLabel": "Îndepărtaţi",
  "removeDescription": "Apăsați pe Delete (Ștergere) pentru a elimina eticheta."
}
